import { TProductRefId } from "@/types/plan";
import { TMigrationRules, TPlan } from "../../types.checkout";
import { TAddOnItem } from "../../utils";

export const PRICING_CARDS_V1: TPlan[] = [
  {
    id: "480212ba-db23-4aaa-9a42-ea81c9e08f39",
    planName: "Selects",
    planDescription: "Unlimited Culling Only Plan",

    promotionText: "",
    productRefId: "AFTERSHOOT_SELECTS" as TProductRefId,

    pricing: {
      currency: "$",

      monthly: 15,
      yearly: 10,

      discountedMonthly: 14,
      discountedYearly: 9,
    },
  },
  {
    id: "ac745b11-7efb-4c51-9460-0eb3263314f4",
    planName: "Essentials",
    promotionText: "",
    productRefId: "AFTERSHOOT_BUNDLE" as TProductRefId,

    planDescription: "Edit with Aftershoot's Pre-built Marketplace Styles",
    pricing: {
      currency: "$",

      monthly: 25,
      yearly: 20,
      discountedMonthly: 23,
      discountedYearly: 18,
    },
  },
  {
    id: "cb7538a1-e998-4d19-954c-694f8f0fbb3c",

    planName: "Pro",
    planDescription:
      "Unlimited Culling and Editing - with your own Personal AI Editing Profile",

    promotionText: "",
    productRefId: "AFTERSHOOT_PRO" as TProductRefId,

    pricing: {
      currency: "$",
      monthly: 48,
      yearly: 40,
      discountedMonthly: 44,
      discountedYearly: 36,
    },
  },
  {
    id: "f4b71ae6-de6b-4555-848a-424643291e4f",

    planName: "Max",
    planDescription: "Perfect for High Volume Photography",
    promotionText: "",
    productRefId: "AFTERSHOOT_MAX" as TProductRefId,
    pricing: {
      currency: "$",
      monthly: 72,
      yearly: 60,
      discountedMonthly: 65,
      discountedYearly: 54,
    },
  },
];

export const V1_ADDON_DISPLAY_NAME_MAP: Record<string, string> = {
  prod_OZ1cZhpkeJ8eTg: "AI Profiles",
};

export const ADDON_CARDS_V1: TAddOnItem[] = [
  {
    id: "prod_OZ1cZhpkeJ8eTg",
    name: "ai_profiles",
    description: null,
    productRefId: "PROFILES",
    featureList: [""],
    pricing: {
      currency: "",
      monthly: 0,
      yearly: 0,
    },
    user_cohorts: [],
    max_count: 600,
    quantity: 0,
    interval: "month",
  },
];

export const FEATURE_CHANGES = [
  {
    title: "What Will You Get",
    changes: [
      "Unlimited AI Retouching included with the Complete Workflow Plan",
      "Cropping, Straightening and Masking included with Editing",
      "Free Raw Rendering",
      "Free online storage for Client Galleries",
    ],
  },
];

export const MIGRATION_RULE_DEFAULT: TMigrationRules = {
  AFTERSHOOT_BUNDLE: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
  AFTERSHOOT_EDITS: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
  AFTERSHOOT_MAX: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
  AFTERSHOOT_PRO: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
  AFTERSHOOT_PRO_TRIAL: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
  AFTERSHOOT_SELECTS: {
    pre_selected: [
      {
        product_id: "AFTERSHOOT_ALL_APP",
        quantity: 1,
      },
    ],
    recommended: [
      {
        product_id: "AFTERSHOOT_CULLING",
        quantity: 1,
      },
      {
        product_id: "AFTERSHOOT_EDITING",
        quantity: 1,
      },
    ],
  },
};
